import { currentCan } from '../permissions/PermissionButton';
import React from 'react';
import { Input, Select } from 'antd';
const { TextArea } = Input;
const { Option } = Select;

const EnhancedEditableField = ({
  value,
  onChange,
  options,
  inputType = "input",
  isLongText = false,
  userPermissions = { isManager: false },
  devisStatus = { VALIDER: false, TRANSFERER: false },
  status, // Additional prop for bonliv status
  displayValue // Display value when not editing
}) => {
  // If status prop exists, use bonliv logic, otherwise use devis logic
  const canEdit = currentCan(null, 'update') && (status
    ? (status !== 'VALIDE' && status !== 'TRANSFERE') || userPermissions?.isManager
    : userPermissions.isManager || (!devisStatus.VALIDER && !devisStatus.TRANSFERER));

  const handleChange = (e) => {
    if (!canEdit) return;
    const newValue = inputType === "select" ? e : e.target.value;
    onChange(newValue);
  };

  if (inputType === "select") {
    if (!canEdit) {
      // Ensure we render a string, not an object
      const displayText = displayValue || (typeof value === 'string' ? value : (value?.value || value?.label || String(value) || 'N/A'));
      return <span>{displayText}</span>;
    }
    
    // Get the current display value for the select
    const getDisplayValue = () => {
      if (!value) return undefined;
      if (typeof value === 'string') return value;
      // If value is an object, try to find matching option
      const matchingOption = options?.find(opt => {
        const optValue = typeof opt === 'object' ? opt.value : opt;
        return optValue === value || (typeof value === 'object' && optValue === value.value);
      });
      return matchingOption ? (typeof matchingOption === 'object' ? matchingOption.value : matchingOption) : value;
    };
    
    return (
      <Select
        value={typeof value === 'object' ? value?.value : value}
        onChange={handleChange}
        className="w-full"
        disabled={!canEdit}
        style={{
          cursor: canEdit ? 'pointer' : 'not-allowed',
          backgroundColor: canEdit ? 'white' : '#f5f5f5'
        }}
      >
        {options?.map(option => {
          // Support both string options and object options {value, label}
          const optionValue = typeof option === 'object' ? option.value : option;
          const optionLabel = typeof option === 'object' ? option.label : option;
          return (
            <Option key={optionValue} value={optionValue}>{optionLabel}</Option>
          );
        })}
      </Select>
    );
  }

  if (isLongText) {
    return (
      <TextArea
        value={value}
        onChange={handleChange}
        className="w-full"
        rows={4}
        autoSize={{ minRows: 1, maxRows: 6 }}
        disabled={!canEdit}
        style={{
          cursor: canEdit ? 'text' : 'not-allowed',
          backgroundColor: canEdit ? 'white' : '#f5f5f5'
        }}
      />
    );
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
      className="w-full"
      disabled={!canEdit}
      style={{
        cursor: canEdit ? 'text' : 'not-allowed',
        backgroundColor: canEdit ? 'white' : '#f5f5f5'
      }}
    />
  );
};

export default EnhancedEditableField;